import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { StatusComponent as Status } from "@/components/ramps/Status";
import { useAnalytics } from "@/hooks/usePostHog";
import { convertStoreToStatusDetails } from "@/lib/status-utils";
import { useRampsStore } from "../stores/use-ramps-store";
import type { ExitEventProperties } from "../utils/analytics";

export const Route = createFileRoute("/ramps/status")({
	component: RouteComponent,
});

function RouteComponent() {
	const store = useRampsStore();
	const { trackPageView, trackExit } = useAnalytics();
	const statusDetails = convertStoreToStatusDetails(store);

	// Track page view
	useEffect(() => {
		trackPageView("status", { page_name: "status" });
	}, [trackPageView]);

	// Track transaction completion/exit based on status
	useEffect(() => {
		const status = statusDetails?.transactionStatus;

		if (status === "COMPLETED" || status === "SUCCESS") {
			// Track successful completion
			const exitProps: ExitEventProperties = {
				exit_type: "completed",
				transaction_id: store.transactionId || statusDetails.referenceNumber,
				transaction_status: status,
				exit_reason: "transaction_completed_successfully",
			};
			trackExit("completed", exitProps);
		} else if (
			status === "CANCELLED" ||
			status === "CANCELED" ||
			status === "FAILED"
		) {
			// Track cancellation/failure
			const exitProps: ExitEventProperties = {
				exit_type: "cancelled",
				transaction_id: store.transactionId || statusDetails.referenceNumber,
				transaction_status: status,
				exit_reason: "transaction_cancelled_or_failed",
			};
			trackExit("cancelled", exitProps);
		}
	}, [
		statusDetails?.transactionStatus,
		store.transactionId,
		statusDetails.referenceNumber,
		trackExit,
	]);

	return (
		<div
			className="min-h-screen flex flex-col max-w-screen-sm mx-auto"
			style={{ backgroundColor: "var(--ramps-background-base)" }}
		>
			<Status
				statusDetails={statusDetails}
				onCancelTransaction={() => console.log("Cancel transaction")} // Todo: is there a case where we will allow users to cancel from the review screen? Might not be possible because the status won't be updated to pending_user_transfer_complete until after they leave this page
			/>
		</div>
	);
}
